export default __webpack_public_path__ + "static/media/im-img.6657856e.webp";